import { Icon } from '@chakra-ui/react';

const CustomPassIcon = (props) => (
  <Icon viewBox="0 0 32 42" fill="none" {...props}>
    <rect x="1" y="1" width="29" height="40" rx="4" fill="white" />
    <rect
      x="1"
      y="1"
      width="29"
      height="40"
      rx="4"
      stroke="#3A4A57"
      strokeWidth="2"
    />
    <path
      d="M11 26.8333V29.6111C11 30.0722 11.3722 30.4444 11.8333 30.4444H14.6111C15.0722 30.4444 15.4444 30.0722 15.4444 29.6111V26.8333C15.4444 26.3722 15.0722 26 14.6111 26H11.8333C11.3722 26 11 26.3722 11 26.8333ZM12.1111 27.1111H14.3333V29.3333H12.1111V27.1111ZM11 35.1667C11 35.6278 11.3722 36 11.8333 36H14.6111C15.0722 36 15.4444 35.6278 15.4444 35.1667V32.3889C15.4444 31.9278 15.0722 31.5556 14.6111 31.5556H11.8333C11.3722 31.5556 11 31.9278 11 32.3889V35.1667ZM12.1111 32.6667H14.3333V34.8889H12.1111V32.6667ZM20.1667 26H17.3889C16.9278 26 16.5556 26.3722 16.5556 26.8333V29.6111C16.5556 30.0722 16.9278 30.4444 17.3889 30.4444H20.1667C20.6278 30.4444 21 30.0722 21 29.6111V26.8333C21 26.3722 20.6278 26 20.1667 26ZM19.8889 29.3333H17.6667V27.1111H19.8889V29.3333ZM16.5556 31.5556H17.6667V32.6667H16.5556V31.5556ZM17.6667 32.6667H18.7778V33.7778H17.6667V32.6667ZM16.5556 33.7778H17.6667V34.8889H16.5556V33.7778ZM18.7778 33.7778H19.8889V34.8889H18.7778V33.7778ZM19.8889 34.8889H21V36H19.8889V34.8889ZM17.6667 34.8889H18.7778V36H17.6667V34.8889ZM18.7778 31.5556H19.8889V32.6667H18.7778V31.5556ZM19.8889 32.6667H21V33.7778H19.8889V32.6667Z"
      fill="#3A4A57"
    />
    <line x1="2" y1="9" x2="31.0689" y2="9" stroke="#3A4A57" strokeWidth="2" />
    <line
      x1="2.03418"
      y1="20"
      x2="31.1031"
      y2="20"
      stroke="#3A4A57"
      strokeWidth="2"
    />
  </Icon>
);

export default CustomPassIcon;
